const TenantPageConstants = {
  SET_USER_CONTEXT: "tenantPage/SET_USER_CONTEXT",
  SET_PARTIAL_USER_CONTEXT: "tenantPage/SET_PARTIAL_USER_CONTEXT",
  INIT_GROUPS: "tenantPage/INIT_GROUPS",
  LOAD_GROUPS: "tenantPage/LOAD_GROUPS",
  LOADING_GROUPS: "tenantPage/LOADING_GROUPS",
  LOADED_GROUPS: "tenantPage/LOADED_GROUPS",
  LOAD_CURRENT_GROUP: "tenantPage/LOAD_CURRENT_GROUP",
  LOADING_CURRENT_GROUP: "tenantPage/LOADING_CURRENT_GROUP",
  LOADED_CURRENT_GROUP: "tenantPage/LOADED_CURRENT_GROUP",
  UPDATE_CURRENT_GROUP: "tenantPage/UPDATE_CURRENT_GROUP",
  UPDATING_CURRENT_GROUP: "tenantPage/UPDATING_CURRENT_GROUP",
  UPDATED_CURRENT_GROUP: "tenantPage/UPDATED_CURRENT_GROUP",
  LOAD_WORKSPACES: "tenantPage/LOAD_WORKSPACES",
  LOADING_WORKSPACES: "tenantPage/LOADING_WORKSPACES",
  LOADED_WORKSPACES: "tenantPage/LOADED_WORKSPACES"
};
export {
  TenantPageConstants as default
};
//# sourceMappingURL=TenantConstants.js.map
